export default "__VITE_ASSET__C4ch4V_2__"